import { UnderMaintenanceWr } from '@pascal/pascal-core';
import { GameBlock } from '../common';
import GameSection from '../../components/mobile/gameSection';

const MobileGame = () => {
  return (
    <div className='mobile'>
      <UnderMaintenanceWr />
      <GameBlock innerComp={GameSection} />
    </div>
  );
};

export default MobileGame;
